<template>
  <NavBar />

  <Header />

  <StatHeadlines />

  <SortQuiz />

  <WomensSafety />

  <!--<Impact />-->

  <SpamTimes />

  <StatNumbers />

  <SliderQuiz />

  <MultipleChoiceQuiz />

  <Confetti />

  <ThankYou />
</template>

<script>
import NavBar from "@/components/NavBar";
import Header from "@/components/Header";
import StatHeadlines from "@/components/StatHeadlines";
import SortQuiz from "@/components/SortQuiz";
import WomensSafety from "@/components/WomensSafety";
//import Impact from "@/components/Impact";
import SpamTimes from "@/components/SpamTimes";
import StatNumbers from "@/components/StatNumbers";
import SliderQuiz from "@/components/SliderQuiz";
import MultipleChoiceQuiz from "@/components/MultipleChoiceQuiz";
import Confetti from "@/components/Confetti";
import ThankYou from "@/components/ThankYou";

export default {
  name: "App",
  components: {
    NavBar,
    Header,
    StatHeadlines,
    SortQuiz,
    WomensSafety,
    //Impact,
    SpamTimes,
    StatNumbers,
    SliderQuiz,
    MultipleChoiceQuiz,
    Confetti,
    ThankYou,
  },
  mounted() {
    this.$gtag.pageview({
      page_path: "/year-in-calling-2020",
    });
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:focus {
  outline: none;
}

:root {
  --blue: #0087ff;
  --purple: #5e35b1;
  --teal: #00a5b9;
  --dark-blue: #3949ab;
  --light-blue: #c7ecff;
  --green: #43a795;
  --red: #ff4130;
  --light-purple: #b197e5;
}

html {
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  color: #fff;
  text-align: center;
}

body {
  background-image: url("./assets/images/bg-pattern.png");
  background-size: 2560px auto;
  background-color: var(--blue);
  transition: background-color 0.8s ease;
}

#app {
  max-width: 100%;
  overflow: hidden;
}

.bg-red {
  background-color: var(--red);
}
.bg-green {
  background-color: var(--green);
}
.bg-purple {
  background-color: var(--purple);
}
.bg-dark-blue {
  background-color: var(--dark-blue);
}
.bg-light-blue {
  background-color: var(--light-blue);
}
.bg-blue {
  background-color: var(--blue);
}
.c-red {
  color: var(--red) !important;
}
.c-green {
  color: var(--green) !important;
}
.c-purple {
  color: var(--purple) !important;
}
.c-dark-blue {
  color: var(--dark-blue) !important;
}
.c-light-blue {
  color: var(--light-blue) !important;
}
.c-blue {
  color: var(--blue) !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.title {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  max-width: 1400px;
}

.question {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  opacity: 0.6;
}

.txt-xxl {
  font-family: "Montserrat", sans-serif;
  font-size: 100px;
  line-height: 122px;
  letter-spacing: -3.45px;
}

.txt-xl {
  font-family: "Montserrat", sans-serif;
  font-size: 60px;
  line-height: 73px;
  letter-spacing: -2.07px;
}

.txt-lg {
  font-family: "Montserrat", sans-serif;
  font-size: 30px;
  line-height: 37px;
  margin-bottom: 30px;
}

.txt-md {
  font-family: "Montserrat", sans-serif;
  font-size: 22px;
  line-height: 27px;
}

.txt-sm {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 15px;
}

p {
  max-width: 800px;
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 30px;
}
.opacity-enter-active,
.opacity-leave-active {
  transition: all 0.5s ease;
}
.opacity-enter-from,
.opacity-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.8, 0.8);
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.5s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(80px);
}

section {
  min-height: 100vh;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.button {
  width: 100%;
  max-width: 480px;
  align-items: center;
  justify-content: center;
  min-width: 280px;
  height: 70px;
  line-height: 70px;
  border-radius: 70px;
  text-align: center;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  background: var(--blue);
  border: none;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  display: flex;
  margin: 32px auto;
}
.button > img {
  margin-right: 20px;
}
.button .button:hover {
  filter: brightness(1.1);
}

.button.button--plain {
  height: 24px;
  line-height: 24px;
  margin: 0 auto;
  background-color: transparent;
}
.button.button--white {
  background-color: white;
  color: black;
}
.button.button--selectable {
  height: 60px;
  line-height: 60px;
  margin: 10px auto;
  background: transparent;
  border: 2px solid #fff;
  padding-left: 32px;
  justify-content: flex-start !important;
  text-align: left !important;
  background-image: url("./assets/icons/radio_button_unchecked-24px.svg");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 32px 32px;
}
.button.button--selectable:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.button.button--selectable.selected {
  background-image: url("./assets/icons/check_circle-24px.svg");
}
.button.button.button--selectable.wrong {
  background-image: url("./assets/icons/cross-border-icon.svg") !important;
}
.button.button.button--selectable.correct {
  background-image: url("./assets/icons/tick-border-icon.svg") !important;
}

.list-item {
  height: 44px;
  line-height: 44px;
  border-radius: 44px;
  text-align: left;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  padding: 0 24px;
}

.stats {
  margin-top: 48px;
  margin-bottom: 32px;
  list-style: none;
}
.stat {
  display: flex;
  margin-bottom: 30px;
}
.stat__icon {
  margin-right: 20px;
}
.stat__bars {
  position: relative;
  flex: 1;
}
.stat__label {
  position: absolute;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  top: -24px;
}
.stat__text {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: left;
  max-width: 720px;
}
.stat__bar {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.stat__bar:before {
  content: "";
  display: block;
  width: 100%;
  height: 20px;
  background: white;
  border-radius: 20px;
  margin-right: 8px;
}
.stat__bar:last-child:before {
  width: 80%;
  background: rgba(255, 255, 255, 0.6);
}
.stats__legend {
  display: flex;
}
.stats__legend > div {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.stats__legend > div:before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 20px;
  margin-right: 8px;
}
.stats__legend > div:last-child:before {
  background: rgba(255, 255, 255, 0.6);
}
@media screen and (min-width: 720px) {
  .stat__text {
    font-size: 40px;
    line-height: 44px;
  }
}
</style>
